// extracted by mini-css-extract-plugin
module.exports = {"container":"LotteryResultsTransfer_raffle_container__xjcUz","logo":"LotteryResultsTransfer_raffle_logo__T8hD9","button":"LotteryResultsTransfer_raffle_button__wtKgm"};